/* eslint-disable no-param-reassign */
import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';

import * as actions from '../actions';

const statusOptions = [
  { label: 'ASSESSED BY BPLO', value: 'ASSESSED BY BPLO' },
  { label: 'REJECTED', value: 'REJECTED' },
]

function GeneratePermit({
  id,
  formData,
  setFormData,
  createSelect,
  postBin,
  getItem,
}) {
  const setModal = useContext(ModalContext);
  useEffect(() => {
    setFormData({
      account_no: '',
      status: '',
      remarks: '',
    })
  }, [])

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    postBin(id, formData, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const onChangeText = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleSubmit} className="py-2">
        <div className="row pb-3">
          <div className="col">
            <label className="form-label d-flex align-items-center">
              BIN
              <span className="text-danger">*</span>
            </label>
            <input
              value={_.get(formData, 'account_no')}
              name="account_no"
              type="text"
              className="form-control"
              onChange={onChangeText}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Status',
                key: 'status',
                label: <div>Status<span className="text-danger">*</span></div>,
              },
              statusOptions
            )}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label className="form-label d-flex align-items-center">
              Remarks
              {_.get(formData, 'status') === 'REJECTED' && (
                <span className="text-danger">*</span>
              )}
            </label>
            <input
              value={_.get(formData, 'remarks')}
              name="remarks"
              type="text"
              className="form-control"
              onChange={onChangeText}
            />
          </div>
        </div>
        <div className="row d-flex justify-content-center pt-2">
          <div>
            <button type="button" onClick={closeModal} className="btn btn-dark mr-1">
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-1"
              disabled={
                _.get(formData, 'account_no') === '' || 
                _.get(formData, 'status') === '' || 
                (_.get(formData, 'status') === 'REJECTED' && 
                _.isEmpty(_.get(formData, 'remarks')))
              }
            >
              Post
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

GeneratePermit.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  postBin: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(GeneratePermit);
